import { useState, useEffect } from 'react'
import { Fetch } from '../../function/Fetch';
import { format, parseISO } from 'date-fns'

type Holiday = {
  name: string
  date: Date
}

type RawHoliday = {
  holidayName: string
  date: string
}

export const useJpHolidays = (startDate: Date, endDate: Date): Holiday[] => {
  const [holidays, setHolidays] = useState<Holiday[]>([])

  useEffect(() => {
    ; (async () => {
      const url = `/customer/api/v1/jp_holidays?start_date=${format(startDate, 'yyyy-MM-dd')}&end_date=${format(endDate, 'yyyy-MM-dd')}`
      const res = await Fetch(url, 'GET', {})
      const json = await res.json() as RawHoliday[]
      setHolidays(json.map(rawHoliday => ({ name: rawHoliday.holidayName, date: parseISO(rawHoliday.date) })))
    })()
  }, [])

  return holidays
}
